import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {
    BackgroundJob,
    UrlRewriteFilter,
    UrlRewriteItemModel
} from "@/models";

export class UrlRewriteService {
    static readonly $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetAllItems(query: UrlRewriteFilter) {
        return this.baseApiFactory.getData<UrlRewriteItemModel[]>('/api/UrlRewrite', query);
    }

    public SynchronizeUrl(value: UrlRewriteItemModel) {
        return this.baseApiFactory.post('/api/UrlRewrite', value);
    }

    SynchronizeAllUrl() {
        return this.baseApiFactory.post<BackgroundJob>('/api/UrlRewrite/SyncAllUrl', {});
    };

    public SaveAlternateUrls(value: UrlRewriteItemModel) {
        return this.baseApiFactory.put('/api/UrlRewrite', value);
    }
}

lazyRegister.service('UrlRewriteService', UrlRewriteService);

